type TDividerProps = { className?: string };

export function Divider(props: TDividerProps) {
  const { className } = props;
  return <div className={`w-full h-[1px] bg-zinc-100 ${className}`} />;
}
